module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_2.8ff979d9b2ca702f004502c920fd97b3.png";